import { privateAxios } from 'services/api/privateAxios';
import { adminAPI } from 'services/api/apiUrl';

export const getCustomerById = id =>
  privateAxios({
    method: 'get',
    baseURL: adminAPI,
    url: `/customer/${id}`,
  });
